import { useTranslation } from "@outschool/localization";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";
import { uniqBy } from "lodash";
import React from "react";

import * as Env from "../../../../shared/Env";
import { seededShuffle } from "../../../../shared/Random";
import { useListingActivitiesByUid } from "../../../hooks/Activity";
import { useTimeZone } from "../../../providers/TimeZoneProvider";
import ListCard from "../cards/ListCard";
import TabContent from "./TabContent";

const followedTeachersListingsQuery = gql`
  query ListingsByTeacherUids(
    $teacherUids: [ID!]!
    $userTimeZone: String
    $learnerAges: [Int]
  ) {
    listingsByTeacherUids(
      teacherUids: $teacherUids
      userTimeZone: $userTimeZone
      learnerAges: $learnerAges
    ) {
      leader {
        uid
        name
        leader_link
      }
      listings {
        activity {
          uid
          slug_id
          details {
            photo
          }
          averageStarRating
          reviewCount
          age_min
          age_max
          title
          titleTranslated
          weekly_meetings
          duration_weeks
          is_ongoing_weekly
          isClub
        }
      }
    }
  }
`;

export default function FavoritesTab({
  savedActivities,
  followedUsers,
  learnerAges,
  random
}: $TSFixMe) {
  const { t } = useTranslation(
    "client\\components\\parentDashboard\\tabs\\FavoritesTab"
  );
  const { timeZone } = useTimeZone();

  //   For classes, show classes you have favorited classes with those most recently favorited at the top
  savedActivities.sort((a: $TSFixMe, b: $TSFixMe) => {
    return new Date(b).valueOf() - new Date(a).valueOf();
  });
  const { listings } = useListingActivitiesByUid(
    uniqBy(savedActivities, "activity_uid")
      .slice(0, 30)
      .map(a => (a as any).activity_uid),
    false
  );

  // Include a carousel for each favorited teacher, and in the carousels show only classes that have open seats and match the ages of at least one of the user’s learners. Teacher carousels can be in random order
  // limit the number of teachers
  const fiveFollowedTeachers = seededShuffle(random, followedUsers).slice(0, 5);
  const { loading, data } = useQueryWithPreviousData(
    followedTeachersListingsQuery,
    {
      skip: !!Env.FEATURE_FLAGS.DISABLE_OPTIONAL_QUERIES,
      variables: {
        teacherUids: (fiveFollowedTeachers as any).map(
          (teacher: $TSFixMe) => teacher.followed_uid
        ),
        userTimeZone: timeZone,
        learnerAges: learnerAges,
        skipRating: false
      },
      context: { doNotRetry: true }
    }
  );

  const carousels = data?.listingsByTeacherUids.map((carousel: $TSFixMe) => (
    <ListCard
      key={`carousel-leader-${carousel.leader.uid}`}
      id={carousel.leader.uid}
      title={carousel.leader.name}
      listings={carousel.listings}
      loading={loading}
      trackingProperties={{
        listings_by_followed_teacher: carousel.leader.uid
      }}
      url={`/teachers/${carousel.leader.leader_link}`}
      subtitle={t("Classes taught by")}
    />
  ));
  return (
    <TabContent
      title={t("Favorited classes and educators")}
      // @ts-ignore TS(2322): Type '{ __typename?: "Listing" | undefined; insert... Remove this comment to see the full error message
      listings={listings}
      listingsLoading={loading}
      carousels={carousels}
      showSaved={false}
    />
  );
}
